import { API } from '.';
import QueryString from 'qs';

class UserService {
    async getUser(userId) {
        try {
            const query = QueryString.stringify(
                {
                    populate: {
                        role: true,
                        company: {
                            fields: ['id', 'name', 'slug', 'hideRaceData'],
                            populate: { logo: true },
                        },
                        school: {
                            fields: ['id', 'name', 'slug'],
                            populate: { logo: true },
                        },
                        resumeReviewer: {
                            fields: ['id'],
                        },
                        coach: {
                            fields: ['id'],
                        },
                        welcomeCallCoach: {
                            fields: ['id'],
                        },
                    },
                },
                { encodeValuesOnly: true },
            );

            const response = await API.get(`/api/users/${userId}?${query}`);
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}

export default UserService;
